import React from 'react'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Button, Modal, Space, Typography } from 'antd'
import { RefundFlowStates, useRefundFlow } from './RefundFlowStates'

interface IRefundFlowModalProps {
  open: boolean
  // Выполняет возврат. При ошибке должен бросить исключение (текст берём из axios-ответа ЮKassa)
  onConfirm: () => Promise<void>
  onClose: () => void
  title?: string
  confirmText?: string
  okText?: string
  cancelText?: string
  loadingText?: string
  successText?: string
}

// Весь флоу возврата в одном окне: подтверждение (Да/Нет) → загрузка → успех/ошибка.
export const RefundFlowModal: React.FC<IRefundFlowModalProps> = ({
  open,
  onConfirm,
  onClose,
  title = 'Возврат средств',
  confirmText = 'Будет произведён возврат денежных средств, подтвердить?',
  okText = 'Да',
  cancelText = 'Нет',
  loadingText = 'Выполняется возврат денежных средств…',
  successText = 'Возврат проведён успешно'
}) => {
  const { step, errorText, runRefund, backToConfirm } = useRefundFlow(open)

  const isLoading = step === 'loading'

  return (
    <Modal
      open={open}
      centered
      footer={null}
      width={520}
      closable={!isLoading}
      maskClosable={!isLoading}
      keyboard={!isLoading}
      onCancel={isLoading ? undefined : onClose}
    >
      {step === 'confirm' && (
        <div style={{ textAlign: 'center', padding: '8px 0' }}>
          <ExclamationCircleOutlined
            style={{ fontSize: 40, color: '#faad14' }}
          />
          <Typography.Title level={5} style={{ marginTop: 12 }}>
            {title}
          </Typography.Title>
          <Typography.Text>{confirmText}</Typography.Text>
          <div>
            <Space style={{ marginTop: 16 }}>
              <Button onClick={onClose}>{cancelText}</Button>
              <Button type='primary' onClick={() => runRefund(onConfirm)}>
                {okText}
              </Button>
            </Space>
          </div>
        </div>
      )}

      <RefundFlowStates
        step={step}
        errorText={errorText}
        loadingText={loadingText}
        successText={successText}
        onClose={onClose}
        onRetry={backToConfirm}
      />
    </Modal>
  )
}
